import React, { useEffect } from "react";
import { useParams } from "react-router-dom";

const Input = ({ placeholder, value, changeHandler }) => {
  return (
    <input
      value={value === null || value === undefined ? '' : value}
      onChange={changeHandler}
      className="join_room_input"
      placeholder={placeholder}
      type="text"
      autoComplete="off"
    />
  );
};

const JoinRoomInputs = (props) => {
  const { roomIdValue, setRoomIdValue, nameValue, setNameValue, isRoomHost } =
    props;

  const { roomId } = useParams();

  useEffect(() => {
    if (roomId && !isRoomHost) {
      setRoomIdValue(roomId);
    }
  }, [roomId, setRoomIdValue, isRoomHost]);

  const handleRoomIdValueChange = (event) => {
    let value = event.target.value.toUpperCase();
    // Remove any existing hyphens
    value = value.replace(/-/g, '');
    // Add hyphens after every 3 characters
    if (value.length > 0) {
      value = value.match(/.{1,3}/g)?.join('-') || '';
    }
    // Limit to 11 characters (XXX-XXX-XXX format)
    if (value.length <= 11) {
      setRoomIdValue(value);
    }
  };

  const handleNameValueChange = (event) => {
    setNameValue(event.target.value);
  };

  return (
    <div className="join_room_inputs_container">
      {!isRoomHost && (
        <div className="input_group">
          <label className="input_label">Meeting ID</label>
          <Input
            placeholder="Enter meeting ID"
            value={roomIdValue}
            changeHandler={handleRoomIdValueChange}
          />
        </div>
      )}
      <div className="input_group">
        <label className="input_label">Your Name</label>
        <Input
          placeholder="Enter your name"
          value={nameValue}
          changeHandler={handleNameValueChange}
        />
      </div>
    </div>
  );
};

export default JoinRoomInputs;
